import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/403')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="p-10 text-4xl font-bold text-accent-foreground">403 | Forbidden</div>
    </div>
  )
}
